// stripHtmlAndTruncate.js

export function getBaseDomainFromUrl(url) {
  try {
    // Ensure the URL can be parsed (adds scheme if missing)
    const withScheme = url.startsWith("http") ? url : `https://${url}`;
    const { hostname } = new URL(withScheme);

    const parts = hostname.split(".").filter(Boolean);

    // Handle localhost or weird cases
    if (parts.length <= 2) return hostname;

    // Return last two segments (example.com)
    return parts.slice(-2).join(".");
  } catch (e) {
    console.error("getBaseDomainFromUrl", e);
    return "";
  }
}
